<script>
import { mapActions, mapGetters } from "vuex";
import EventBus from "@/eventBus";
import { fetchAllMixin } from "@/mixins/fetchAllMixin";

export default {
  name: "ThePagesLoader",

  mixins: [fetchAllMixin],

  computed: {
    ...mapGetters("pages", ["isPageLoaded", "isPageLoading"]),
    ...mapGetters("program", ["coreProgramMeta", "isTeamsFeatureOn"])
  },

  mounted() {
    // Fetch the 3 main pages after login (currently in the same order as the sidebar menu)
    // Note: challenge detail page, team detail page, friends page, and profile page not included as they are loaded upon first visit
    this.toFetchOrNotToFetch(this, "MyDashboard");

    // todo: we should look into the usefulness of this, I feel this may be causing more bad than good.
    EventBus.onPageLoadedMyDashboard(() => {
      this.toFetchOrNotToFetch(this, "Challenges");

      if (this.isTeamsFeatureOn) {
        this.toFetchOrNotToFetch(this, "Teams");
      }
    });
  },

  methods: {
    ...mapActions([
      "members/fetchMemberStepData",
      "members/fetchJournals",
      "members/fetchChallenges",
      "members/fetchChallengeInvites",
      "members/fetchRequestedJoinMessages",
      "members/fetchActivities",
      "members/fetchMemberTeamInvites",
      "members/fetchMemberTeams",
      "program/fetchFeaturedChallenge",
      "program/fetchChallenges",
      "program/fetchJournals",
      "program/fetchStepData",
      "program/fetchLeaderboardData",
      "program/fetchAggregateData",
      "program/fetchProgramTeams"
    ]),
    ...mapActions("pages", [
      "setPageLoaded",
      "setPageLoading",
      "fetchAllPageMyDashboard",
      "fetchAllPageSitewide",
      "fetchAllPageChallenges",
      "fetchAllPageTeams"
    ]),

    fetchAllPage(vm, page) {
      let member = this.$auth.user();
      // ensure member is logged in
      if (this._.has(member, "programId")) {
        switch (page) {
          case "MyDashboard":
            return vm.fetchAllPageMyDashboard(member);
          case "Sitewide":
            return vm.fetchAllPageSitewide(member.programId);
          case "Challenges":
            return vm.fetchAllPageChallenges(member);
          case "Teams":
            return vm.fetchAllPageTeams();
          default:
            break;
        }
      }
    }
  },

  render(h) {
    return h();
  }
};
</script>

<style lang="sass" scoped></style>
